import React from 'react';
import { Card, Empty, List, Tag, Typography } from 'antd';
import type { BqInsight, BqSeverity } from '@/types';
import { dayLabel } from './bqMath';
import { WholeGameTag } from './WholeGameTag';

const { Text } = Typography;

const SEVERITY: Record<BqSeverity, { color: string; label: string }> = {
  critical: { color: 'red', label: 'Critical' },
  warning: { color: 'orange', label: 'Warning' },
  info: { color: 'blue', label: 'Info' },
  good: { color: 'green', label: 'Good' },
};

/** Rule-based findings of the last 3 built days, most severe first; always the whole game. */
export const BqInsightsList: React.FC<{ insights: BqInsight[]; wholeGame?: boolean }> = ({
  insights,
  wholeGame,
}) => (
  <Card
    size="small"
    title={
      <>
        Things to look at
        <WholeGameTag show={wholeGame} />
      </>
    }
  >
    {insights.length === 0 ? (
      <Empty
        description="No findings in the last 3 built days"
        image={Empty.PRESENTED_IMAGE_SIMPLE}
      />
    ) : (
      <List
        size="small"
        dataSource={insights}
        rowKey={(i) => `${i.date}|${i.kind}|${i.title}`}
        renderItem={(i) => (
          <List.Item>
            <div>
              <Tag color={SEVERITY[i.severity].color}>{SEVERITY[i.severity].label}</Tag>
              <Text strong>{i.title}</Text>{' '}
              <Text type="secondary" style={{ fontSize: 12 }}>
                · {dayLabel(i.date)}
              </Text>
              <div>
                <Text type="secondary" style={{ fontSize: 12 }}>
                  {i.detail}
                </Text>
              </div>
            </div>
          </List.Item>
        )}
      />
    )}
  </Card>
);
